import React from 'react';
import ReactDOM from 'react-dom/client';
import MedShareApp from './MedShareApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MedShareApp />
  </React.StrictMode>
);
